import { useState, useEffect, useRef } from "react";
export default function StatsBar() {
  const ref = useRef<HTMLDivElement>(null);
  const [visible, setVisible] = useState(false);
  useEffect(() => {
    const obs = new IntersectionObserver(([e]) => {
      if (e.isIntersecting) setVisible(true);
    }, {
      threshold: 0.1
    });
    if (ref.current) obs.observe(ref.current);
    return () => obs.disconnect();
  }, []);
  const stats = [{
    numberText: "#3",
    isYellow: true,
    suffix: "/ 12",
    description: "Internal benchmark rank, above every open-weight model tested"
  }, {
    numberText: "2",
    isYellow: false,
    suffix: "B params",
    description: "Ternary weights (−1, 0, +1) — ~1.1 GB on disk"
  }, {
    numberText: "4",
    isYellow: false,
    suffix: "GB VRAM",
    description: "Trained & aligned on one RTX 3050 laptop"
  }, {
    numberText: "0",
    isYellow: false,
    suffix: "cloud GPUs",
    description: "No datacenter. No cloud bill. ~6 tok/s on CPU alone"
  }];
  return <section style={{
    backgroundColor: "#0b0b0d",
    color: "rgb(244, 244, 243)",
    fontFamily: 'Geist, "Hanken Grotesk", system-ui, -apple-system, sans-serif'
  }}>
      <style>{`
        @import url('https://fonts.googleapis.com/css2?family=Inter:wght@400;500;800&display=swap');
        .stats-grid {
          display: grid;
          gap: 18px;
          grid-template-columns: repeat(4, 1fr);
        }
        @media (max-width: 767px) {
          .stats-grid {
            grid-template-columns: repeat(2, 1fr);
          }
        }
        @media (max-width: 480px) {
          .stats-grid {
            grid-template-columns: repeat(1, 1fr);
          }
        }
        .fade-up {
          opacity: 0;
          transform: translateY(16px);
          transition: opacity 620ms cubic-bezier(0.2, 0.7, 0.2, 1), transform 620ms cubic-bezier(0.2, 0.7, 0.2, 1);
        }
        .fade-up.in {
          opacity: 1;
          transform: none;
        }
      `}</style>
      <div className="page-container" style={{
      paddingTop: "clamp(48px, 6vw, 88px)",
      paddingBottom: "clamp(48px, 6vw, 88px)",
      paddingLeft: "clamp(20px, 4vw, 56px)",
      paddingRight: "clamp(20px, 4vw, 56px)"
    }}>
        <div ref={ref} className="stats-grid">
          {stats.map((stat, i) => <div key={i} className={`fade-up${visible ? " in" : ""}`} style={{
          transitionDelay: `${i * 100}ms`
        }}>
              <div style={{
            display: "flex",
            alignItems: "baseline",
            gap: "4px",
            marginBottom: "8px",
            flexWrap: "wrap"
          }}>
                <span style={{
              fontSize: "52px",
              fontWeight: 800,
              lineHeight: 1,
              color: stat.isYellow ? "#f5c518" : "#f4f4f3",
              fontFamily: 'Geist, "Hanken Grotesk", system-ui, -apple-system, sans-serif'
            }}>
                  {stat.numberText}
                </span>
                <span style={{
              fontSize: "20px",
              fontWeight: 500,
              lineHeight: 1,
              color: "#f4f4f3",
              fontFamily: 'Geist, "Hanken Grotesk", system-ui, -apple-system, sans-serif'
            }}>
                  {stat.suffix}
                </span>
              </div>
              <p style={{
            fontSize: "13px",
            fontWeight: 400,
            color: "#b9b9bd",
            lineHeight: 1.5,
            margin: 0,
            fontFamily: 'Geist, "Hanken Grotesk", system-ui, -apple-system, sans-serif'
          }}>
                {stat.description}
              </p>
            </div>)}
        </div>
      </div>
    </section>;
}